import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import { purchaseOrderAddItem } from '../../redux/actions/purchaseOrders';
import { getAssignmentThresholds } from '../../redux/actions/assignments';

const ItemLine = ({ 
  payload,
  activeShippingAddress,
  products,
  hasvariations, 
  productId, 
  itemId, 
  smallThumbnailUrl, 
  inventoryTracking, 
  options, 
  name,
  binPickingNumber,
  sku,
  upc,
  type,
  rowId,
  quantity,
  price,
  assignments,
  thresholds,
  getRelatedThresholds,
  assignment,
  addItem,
  setModalProductId,
  setModalVariationId,
  setModalOptions,
  setModalProductName,
  setModalType,
  setModalAssignment,
  setShowAddSupplierAssignmentModal,
  setShowUpdateSupplierAssignmentModal,
  setShowDeleteSupplierAssignmentModal,
  setShowOtherSuppliersModal,
  activeSupplier,
  purchaseOrderLines,
  showInventoryModal,
  settings,
  accountUnits,
  inStockFilter,
  setModalY, }) => {

  const [assignmentQuantities, setAssignmentQuantities] = useState({});

  useEffect(() => {
    if(activeShippingAddress?.address) {
      if(type === 'variation') {
        // Do not search if currently searching
        if(thresholds.searchingAssignmenThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${productId}/${itemId}`)  >= 0) { return; };

        // Do not search if the value is already there
        if(Object.keys(thresholds.assignmentThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${productId}/${itemId}`)  >= 0) { return; };

        // Search if the key doesn't exist
        getRelatedThresholds(payload, activeShippingAddress.id, productId, itemId);
      } else {
        // Do not search if currently searching
        if(thresholds.searchingAssignmenThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${productId}/null`)  >= 0) { return; };

        // Do not search if the value is already there
        if(Object.keys(thresholds.assignmentThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${productId}/null`)  >= 0) { return; };

        // Search if the key doesn't exist
        getRelatedThresholds(payload, activeShippingAddress.id, productId, null);
      }

    }
  }, [activeShippingAddress]);


  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }

  const showOtherSuppliersModal = (event) => {
    setModalY(event.pageY);
    setModalProductId(productId);
    
    if(type === 'variation') {
      setModalVariationId(itemId);
    } else {
      setModalVariationId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);

    setShowOtherSuppliersModal(true);
  }

  const showAddSupplierAssignmentModal = (event) => {
    setModalY(event.pageY);
    setModalProductId(productId);
    
    if(type === 'variation') {
      setModalVariationId(itemId);
    } else {
      setModalVariationId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);

    setShowAddSupplierAssignmentModal(true);
  }

  const showUpdateSupplierAssignmentModal = (event) => {
    setModalY(event.pageY);
    setModalProductId(productId);
    
    if(type === 'variation') {
      setModalVariationId(itemId);
    } else {
      setModalVariationId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);
    setModalAssignment(assignment?.body);

    setShowUpdateSupplierAssignmentModal(true);
  }

  const showDeleteSupplierAssignmentModal = (event) => {
    setModalY(event.pageY);
    setModalProductId(productId);

    if(type === 'variation') {
      setModalVariationId(itemId);
    } else {
      setModalVariationId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);
    setModalAssignment(assignment?.body);

    setShowDeleteSupplierAssignmentModal(true);
  }

  const showOtherSuppliersbutton = () => {
    let fieldKey = '';

    if(type === 'variation') {
      fieldKey = `${productId}/${itemId}`;
    } else {
      fieldKey = productId;
    }

    if(products?.searchedVariationsMetafields && products?.searchedVariationsMetafields[fieldKey]) {
      return (products?.searchedVariationsMetafields[fieldKey]?.filter(assignment => assignment.supplier_id !== activeSupplier?.id).length > 0)
    }

    if(products?.searchedProductsMetafields && products?.searchedProductsMetafields[fieldKey]) {
      return (products?.searchedProductsMetafields[fieldKey]?.filter(assignment => assignment.supplier_id !== activeSupplier?.id).length > 0)
    }

    return false;
  }

  const handleAdd = (assignment) => {
    let itemData = {};

    if(type === 'variation') {
      itemData.productId = productId;
      itemData.variationId = itemId;
    } else {
      itemData.productId = productId;
      itemData.variationId = null;
    }

    itemData.productName = name;
    itemData.imageUrl = smallThumbnailUrl;
    itemData.options = options;
    itemData.sku = sku;
    itemData.upc = upc;
    itemData.supplier_sku = assignment?.body?.supplier_sku;
    itemData.supplier_price = assignment?.body?.supplier_price;
    itemData.minimumOrder = assignment?.body?.minimum_order;
    
    if(settings?.settings?.order_multiples) {
      itemData.orderMultiple = assignment?.body?.order_multiple;
    }

    if(settings?.settings?.pack_quantities) {
      itemData.packQuantity = assignment?.body?.pack_quantity;
    }

    itemData.setQuantity = assignmentQuantities[`${productId}/${itemId || 'null'}`] || assignment?.body?.minimum_order;

    addItem(payload, itemData);
  }

  const updateAssignmentQuantityField = (event, key) => {
    let value = event.target.value;
    let newQuantities = { ...assignmentQuantities };

    newQuantities[key] = parseInt(value);
    setAssignmentQuantities(newQuantities);
  }

  if(inStockFilter && !quantity) {
    return(
      <></>
    )
  }

  return(
    <>
      <div className="has-hover sku-line flex-container">
        <div className={`flex-1 ${type === 'variation' && 'left-15'}`}>
          <div className="flex-container">
            <div className="left-15">
              { smallThumbnailUrl && <img src={smallThumbnailUrl} /> }
              { !smallThumbnailUrl && <p>No image</p>}
            </div>
          </div>
        </div>

        <div className="flex-2">
          <div className="left-15">
            <h4>Assignment Details</h4>
            { (assignments.status === 'success') && assignment && <ul>
              <li><strong>Supplier SKU</strong>: <span className="inline-text-tag">{assignment?.body?.supplier_sku || "Not set"}</span></li>
              <li><strong>Supplier Price</strong>: <span className="inline-text-tag">{assignment?.body?.supplier_price ? format(assignment?.body?.supplier_price) : "Not set"}</span></li>
              <li><strong>Minimum Order Quantity</strong>: <span className="inline-text-tag">{parseInt(assignment?.body?.minimum_order) || "Not set"}</span></li>
              { settings?.settings?.order_multiples && 
                <li><strong>Order Multiple</strong>: <span className="inline-text-tag">{assignment?.body?.order_multiple || "Not set"}</span></li>
              }
              { settings?.settings?.pack_quantities && 
                <li><strong>Pack Quantity</strong>: <span className="inline-text-tag">{assignment?.body?.pack_quantity || "Not set"}</span></li>
              }
            </ul> }
            { (assignments.status === 'success') && !assignment &&
              <p>No supplier assignment</p>
            }
            { (assignments.status === 'success') && assignment &&
              <>
                <button
                  className="btn btn-default"
                  onClick={(e) => showUpdateSupplierAssignmentModal(e)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Update supplier assignment</span>
                </button>

                <button
                  className="btn btn-default btn--destructive"
                  onClick={(e) => showDeleteSupplierAssignmentModal(e)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Delete supplier assignment</span>
                </button>

              </>
            }

            { assignments.status !== 'success' &&
              <LoadingSpinner size="xxSmall" statusText="Loading assignments"/>
            }
          </div>
        </div>

        <div className="flex-2">
          <div className="flex-container">
            <h4>{name}</h4>
          </div>
          <ul>
            { options && options.map(option =>
                <li>
                  <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                </li>
              )
            }
            { !options &&
              <div className="text-small warning">
                Base Product
              </div>
            }

            <li>
              <strong>Inventory</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ quantity }</span>
            </li>

            { activeShippingAddress?.address && thresholds.assignmentThresholds[`${activeShippingAddress?.id}/${productId}/${itemId || 'null'}`] &&
              <li>
                <p>
                  <strong>Target Inventory</strong>: &nbsp;
                  <span className="inline-text-tag">{ thresholds.assignmentThresholds[`${activeShippingAddress?.id}/${productId}/${itemId || 'null'}`]?.target_inventory }</span>
                </p>
              </li>
            }
          </ul>

          { inventoryTracking !== 'none' &&
            <button
              className="btn btn-link"
              onClick={(e) => showInventoryModal(e, inventoryTracking, productId, itemId, quantity)}
            >
              <span className="svg-icon">
                <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
              </span>
              <span className="gwt-InlineLabel">View Inventory Levels</span>
            </button>
          }

          { showOtherSuppliersbutton() &&
            <button
              className="btn btn-link"
              onClick={(e) => showOtherSuppliersModal(e)}
            >
              <span className="svg-icon">
                <svg aria-hidden="true" fill="currentColor" height="24" stroke="currentColor" stroke-width="0" viewBox="0 0 24 24" width="24" className="base__StyledIcon-sc-a9u0e1-0 emfseH"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"></path></svg>
              </span>
              <span className="gwt-InlineLabel">View Other Suppliers</span>
            </button>
          }
          
        </div>
        <div className="flex-1">
          <>
            { !(Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${productId}/${itemId}` || ( !options && key === `${productId}/null` )) )) &&
              <>
                { assignment &&
                  <div className="flex-container flex-end">
                    <span>QTY: &nbsp;&nbsp;</span>
                    <div className="width-50">

                        <div className="fieldset">
                          <div className="field field--medium field--filled">
                            <span className="fieldset__svg-icon"></span>
                            <label className="field__label">QTY</label>
                            <input
                              className="field__input"
                              label=""
                              onChange={(e) => updateAssignmentQuantityField(e, `${productId}/${itemId || 'null'}`)}
                              type="number"
                              value={assignmentQuantities[`${productId}/${itemId || 'null'}`] || assignment?.body?.minimum_order || 1}
                            />
                            <div className="field__placeholder">QTY</div>
                            <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                            <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                          </div>
                        </div>

                    </div>
                  </div>
                }

                <button
                  className="btn btn-default"
                  disabled={!assignment}
                  onClick={() => handleAdd(assignment)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Add to Purchase Order</span>
                </button>
              </>
            }
            { Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${productId}/${itemId}` || ( !options && key === `${productId}/null` )) ) &&
              <button
                className="btn btn-default"
                disabled
              >
                <span className="svg-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1585.2474c.4156.3637.4578.9955.0941 1.4111l-7 8a1 1 0 0 1-1.4597.0486l-4-4c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0l3.2442 3.2442L11.7474.3415c.3637-.4156.9955-.4577 1.4111-.094Z"/></svg>
                </span>
                <span className="gwt-InlineLabel">Added to Purchase Order</span>
              </button>
            }
            {!assignment &&
              <>
                <br/>
                <button
                  className="btn btn-default"
                  onClick={(e) => showAddSupplierAssignmentModal(e)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Add supplier assignment</span>
                </button>
              </>
            }
          </>
          

        </div>
      </div>
      <hr/>
    </>
  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  assignments: state.assignments,
  products: state.products,
  purchaseOrderLines: state.purchaseOrderLines,
  thresholds: state.thresholds,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData)),
  getRelatedThresholds: (payload, productId, variationId) => dispatch(getAssignmentThresholds(payload, productId, variationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLine);
